import { QueryClientProvider } from '@tanstack/react-query';
import { AnalyticsProviderComponent } from './AnalyticsProvider.component';
import { jsx as _jsx } from "react/jsx-runtime";
export default function AnalyticsProviderContainer(_ref) {
  var children = _ref.children,
    initialAnalyticsData = _ref.initialAnalyticsData,
    queryClient = _ref.queryClient,
    isBusinessBooker = _ref.isBusinessBooker;
  return _jsx(QueryClientProvider, {
    client: queryClient,
    children: _jsx(AnalyticsProviderComponent, {
      initialAnalyticsData: initialAnalyticsData,
      isBusinessBooker: isBusinessBooker,
      children: children
    })
  });
}